import { CadstromObjectType } from '@cadstrom/cadstrom-shared';

import { AgentConversationUidResult } from './results/agent-conversation-uid-result.js';
import { BuildUidResult } from './results/build-uid-result.js';
import { OrganizationUidResult } from './results/organization-uid-result.js';
import { PackageUidResult } from './results/package-uid-result.js';
import { ProjectUidResult } from './results/project-uid-result.js';

import type { CadstromUidResultComponent } from './cadstrom-uid-types.js';

/**
 * Maps a `CadstromObjectType` to the component that resolves and renders a
 * command-bar result for a UID of that type.
 *
 * To support pasting a new object type's UID into the command bar, add an
 * entry here. Any valid Cadstrom UID whose type is absent from this map is
 * still recognized but produces no result.
 */
export const cadstromUidResultHandlers: Partial<Record<CadstromObjectType, CadstromUidResultComponent>> = {
	[CadstromObjectType.AgentChatConversation]: AgentConversationUidResult,
	[CadstromObjectType.Build]: BuildUidResult,
	[CadstromObjectType.Organization]: OrganizationUidResult,
	[CadstromObjectType.PackageStorePackage]: PackageUidResult,
	[CadstromObjectType.Project]: ProjectUidResult,
};
